// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"1ea31d56","287":"818212ae","850":"874dadd3","936":"1896d0ef"}[chunkId] + ".css";
};